module.exports = __webpack_public_path__ + "static/img/28.36cfb62.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/28.png
// module id = PGWZ
// module chunks = 0